



















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UserViewModel, UserService } from '../../api/user';
@Component({})
export default class ImportUser extends Vue {
  private service: UserService = new UserService();
  private data: UserViewModel = this.service.NewModel;
  private rules = {
    content: [{required: true, message: '请输入导入信息', trigger: 'blur'}],
  };
  @Emit('OnCancel')
  private OnCancel() { }
  @Emit('OnSaved')
  private OnSaved() { }

  private btnSave_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        this.service.ImportUser(this.data).then((response: any) => {
          (this.$refs['edit-form'] as any).resetFields();
          this.OnSaved();
        });
      }
    });
  }
 }
